// Copyright (c) 2023 WiseTime. All rights reserved.

import { TimeGroup, TimelineMarker, TimeRow } from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { TimesheetFieldConfig } from "../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

// Timeline types that are shared outside the feature.

export type TimeRowsCache = {
  [id: string]: TimeRow,
}

export type TimeGroupsCache = {
  [id: string]: TimeGroup,
}

// Frontend validation errors before posting to server
export type PostErrorMessages = {
  [id: string]: string,
}

export type TimeGroupFieldConfigsCache = {
  [timeGroupId: string]: string[],
}

export type TimesheetFieldConfigsCache = {
  [configHash: string]: TimesheetFieldConfig,
}

// Representation of a time marker as a row in the timeline UI.
// It has fields that are consistent with TimeRow so that the 2 types can be mixed and sorted.
export type TimeMarkerRow = {
  activityHour: number,
  firstObservedInHour: number,
  timeZone: string,
} & TimelineMarker

export type TimelineRow = (TimeRow | TimeMarkerRow)

export const isTimeRow = (timelineRow: unknown): timelineRow is TimeRow =>
  // Unlike time rows, time groups and time markers do not have timeGroupId property.
  (timelineRow as TimeRow).timeGroupId !== undefined

